import { STATUS_CODE } from '@kc-console/core';

import type { Env, ServiceAppState } from '@kc-console/context';

/**
 * Onboarding 초기 기본 상태
 * @description
 * - determineI18nResourceGuard가 Guard<ServiceAppState & BaseState> 타입이므로 ServiceAppState 사용
 * - Account/Baguni와 동일한 패턴 (인증 관련 필드는 빈 값으로 초기화)
 * - Onboarding은 프로젝트 컨텍스트 없이 동작하므로 scope: 'unscope'
 */
export const INITIAL_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  token: '',
  domainId: '',
  domainName: '',
  projectId: '',
  projectName: '',
  serviceKeyword: 'onboarding',
  region: undefined,
  language: '',
  displayLanguage: '',
  scope: 'unscope',
  userId: '',
  userName: '',
  defaultProjectId: '',
  accessibleProjects: [],
  error: null,
  isRegionForced: false,
  isProjectForced: false,
  ssrConfig: null,
};

/**
 * Onboarding 에러 페이지 기본 상태
 * @description
 * _error.tsx의 getInitialProps에서 사용
 * Account와 달리 ServiceAppState를 사용 — determineLanguageGuard가 Guard<ServiceAppState> 타입이므로
 * 에러 페이지에서 토큰이 없는 경우(token: '') getCurrentLanguage 내부에서 쿠키 fallback으로 안전하게 동작
 */
export const ERROR_PAGE_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  token: '',
  domainId: '',
  domainName: '',
  projectId: '',
  projectName: '',
  serviceKeyword: 'onboarding',
  region: undefined,
  language: '',
  displayLanguage: '',
  scope: 'unscope',
  userId: '',
  userName: '',
  defaultProjectId: '',
  accessibleProjects: [],
  error: null,
  isRegionForced: false,
  isProjectForced: false,
  ssrConfig: null,
};
